exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vaillantCont[data-v-249074c3] {\r\n  height: 100%;\n}\n.wa_icon[data-v-249074c3]{\r\n  max-width: 40px;\r\n  margin-top: -11px;\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-249074c3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contact/index.vue
// module id = sCpE
// module chunks = 2